import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const fmtSsn = (v) => { const d = v.replace(/\D/g, "").slice(0, 9); return [d.slice(0, 3), d.slice(3, 5), d.slice(5)].filter(Boolean).join("-"); };

export default function SsnControl({ p, policy, reload }) {
  const [shown, setShown] = useState("");
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState("");
  if (!policy?.collect && !(p.ssn_last4 && policy?.can_remove)) return null;
  const reveal = async () => {
    if (shown) return setShown("");
    try { const { data } = await api.get(`/patients/${p.id}/ssn`); setShown(data.ssn); } catch (e) { toast.error(errMsg(e)); }
  };
  const save = async (v) => {
    try { await api.put(`/patients/${p.id}/ssn`, { ssn: v.replace(/\D/g, "") }); toast.success(v ? "SSN saved (audited)" : "SSN removed (audited)"); setEdit(false); setShown(""); setVal(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <span className="text-slate-500">SSN</span>
      <span className="flex flex-wrap items-center gap-2">
        <span className={shown || p.ssn_last4 ? "font-mono" : ""} data-testid="chart-ssn">{shown || (p.ssn_last4 ? `***-**-${p.ssn_last4}` : "Not on file")}</span>
        {!policy.collect && <button className="text-xs underline text-red-700" onClick={() => save("")} data-testid="chart-ssn-remove-legacy">Remove (facility no longer collects SSN)</button>}
        {policy.manage && p.ssn_last4 && <button className="text-xs underline" onClick={reveal} data-testid="chart-ssn-reveal">{shown ? "Hide" : "View"}</button>}
        {policy.manage && <button className="text-xs underline" onClick={() => setEdit(!edit)} data-testid="chart-ssn-edit">{p.ssn_last4 ? "Change" : "Add"}</button>}
      </span>
      {edit && (
        <span className="col-span-2 flex gap-2 mt-1" data-testid="chart-ssn-form">
          <Input value={val} onChange={(e) => setVal(fmtSsn(e.target.value))} placeholder="###-##-####" inputMode="numeric" autoComplete="off" className="h-9" data-testid="chart-ssn-input" />
          <Button size="sm" className="btn-brand" disabled={val.replace(/\D/g, "").length !== 9} onClick={() => save(val)} data-testid="chart-ssn-save">Save</Button>
          {p.ssn_last4 && <Button size="sm" variant="outline" onClick={() => save("")} data-testid="chart-ssn-remove">Remove</Button>}
        </span>
      )}
    </>
  );
}
